import { defineStore } from 'pinia';
import { fetchWrapper } from '@/utils/helpers/fetch-wrapper';
import axios from '../../src/utils/axios';
import type { User, UserLoginData } from '@/types/index';



interface UserState {
    user: User
}


const baseUrl = `${import.meta.env.VITE_BASE_URL}`;
const apiBaseUrl = `${import.meta.env.VITE_}`;
const authUrl = `${import.meta.env.VITE_API_AUTH_URL}`;
export const useAuthStore = defineStore('authStore', {
    // id: 'auth',
    state: ():UserState => {

        
        // initialize state from local storage to enable user to stay logged in
        // @ts-ignore

        const userInLocalStorage = localStorage.getItem('user');

        if(userInLocalStorage) {
            return {
                user: JSON.parse(userInLocalStorage)
            }
        }

        return {user: {} as User };

        // user: JSON.parse(localStorage.getItem('user')),
        // returnUrl: null,
        // token: null,
        // authenticated: false,
    },
   
    actions: {
        async login(user: { email: string; password: string }) {
           
            try {
                await axios.get(baseUrl + '/sanctum/csrf-cookie');
                const response = await axios.post(authUrl + '/login', user);
            
             
                localStorage.setItem('user', JSON.stringify(response.data.user));
                localStorage.setItem('token', response.data.access_token);
                localStorage.setItem('role', response.data.role);
                this.user = response.data.user;
            
                return {
                  success: true,
                  data: response.data,
                };
            
              } catch (error: any) {
                console.error('Full login error:', error); 

                const hasResponse = !!error?.response;
                const status = hasResponse ? error.response.status : null;
                const message = hasResponse
                  ? error.response.data?.message || 'Login failed.'
                  : error.message || 'Network error or server unreachable';
              
                if (status === 403 && user.email) {
                  localStorage.setItem('verify_email', user.email);
                }
              
                return {
                  success: false,
                  status,
                  message,
                  errors: hasResponse ? error.response.data?.errors ?? null : null,
                };
              }
            
              
          },
       async logout() {
          try {
            // Try hitting backend logout only if token exists
            const token = localStorage.getItem('token');
            if (token) {
              await axios.post(authUrl + '/logout');
            }
          } catch (error) {
            // Ignore error — likely due to expired token
            console.warn('Logout failed (likely expired):', error);
          } finally {
            // Always clean up local session
            this.user = {} as User;
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            localStorage.removeItem('role');
            localStorage.removeItem('verify_email');
            delete axios.defaults.headers.common['Authorization'];
          }
        }

    }
});
